import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AccessLinkRequestForbiddenError } from '../errors/AccessLinkRequestForbiddenError';
import { LinkRequestAcceptationFailedError } from '../errors/LinkRequestAcceptationFailedError';
import { LinkRequestMustBePendingError } from '../errors/LinkRequestMustBePendingError';
import { LinkRequestRejectionFailedError } from '../errors/LinkRequestRejectionFailedError';

import { BobHttpClient } from './BobHttpClient';
import { LinkRequestsGateway } from './LinkRequestsGateway';

const LINK_REQUEST_ENDPOINT = '/link-request-api/public/v1';

@Injectable()
export class HttpLinkRequestsGateway implements LinkRequestsGateway {
    constructor(protected http: BobHttpClient) {}

    acceptLinkRequest(token: string): Observable<void> {
        return this.http.post<void>(`${LINK_REQUEST_ENDPOINT}/requests/${token}/accept`, {}).pipe(
            catchError((errorResponse: HttpErrorResponse) => {
                if (errorResponse.error.errorCode === 'USER_IS_NOT_OWNER_SITE') {
                    return throwError(() => new AccessLinkRequestForbiddenError(errorResponse.error.message));
                }
                if (errorResponse.error.errorCode === 'SHOULD_BE_PENDING') {
                    const { currentState, message } = errorResponse.error;
                    return throwError(() => new LinkRequestMustBePendingError(currentState, message));
                }
                return throwError(() => new LinkRequestAcceptationFailedError());
            }),
        );
    }

    rejectLinkRequest(token: string): Observable<void> {
        return this.http.post<void>(`${LINK_REQUEST_ENDPOINT}/requests/${token}/reject`, {}).pipe(
            catchError((errorResponse: HttpErrorResponse) => {
                if (errorResponse.error.errorCode === 'USER_IS_NOT_OWNER_SITE') {
                    return throwError(() => new AccessLinkRequestForbiddenError(errorResponse.error.message));
                }
                if (errorResponse.error.errorCode === 'SHOULD_BE_PENDING') {
                    const { currentState, message } = errorResponse.error;
                    return throwError(() => new LinkRequestMustBePendingError(currentState, message));
                }
                return throwError(() => new LinkRequestRejectionFailedError());
            }),
        );
    }
}
